import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Retention } from '../../../../interfaces/Sales/Catalogs/retentions';
import GenericPromises from '../../../../api/GenericPromises';
import { Menuitem } from '../../../../interfaces/Security/menu';
import { Spinner } from '../../../../components/Commons/Spinner/Spinner';
import { Header } from '../../../../components/Header';
import { Button } from '@mui/material';
import { UpdateRetentions } from './update';
import { usePermissions } from '../../../../hooks/usePermissions';
import { GenericDialog } from '../../../../components/Dialogs/Dialog';
import { ButtonStyled } from '../../../../theme/buttons';
import useSnackBar from '../../../../components/Commons/SnackBar/useSnackBar';

export const ViewRetentions = () => {

    const [t] = useTranslation("global");
    const location = useLocation();
    const navigate = useNavigate();
    const [retentionLocal, setRetentionLocal] = useState<Retention>();
    const [openDialog, setOpenDialog] = useState(false);
    const [dataloaded, setDataLoaded] = useState(false);
    const { GenericGetResource, GenericDeleteResource } = GenericPromises();
    const [resourceScreen, setResourceScreen] = useState<Menuitem>();
    const { GetResourceByUrl } = usePermissions();
    const { showSnackBar,SnackbarComponent}= useSnackBar();

    const onDelete = () => {
        GenericDeleteResource(`/retentions/${retentionLocal?.retention_id}`)
            .then(() => {
                setOpenDialog(false);
                navigate("/retentions", { state: { method: "delete" }, replace: true });
            })
            .catch((error) => {
                showSnackBar(error.message,'error');
                setOpenDialog(false);
            })
    }


    useEffect(() => {
        if (location.state === null) return navigate("/retentions", { state: {}, replace: true });
        GenericGetResource(`/retentions/${location.state.row.retention_id}`)
            .then(
                (response) => {
                    setRetentionLocal(response.data);

                    GetResourceByUrl(`/retentions`)
                        .then((response1) => {
                            setResourceScreen((prev) => response1);
                            setDataLoaded(true);
                        })
                        .catch((error) => {
                            showSnackBar(error.message,'error');
                        });
                }
            ).catch((error) => {
                showSnackBar(error.message,'error');
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {!dataloaded && <Spinner />}
            {dataloaded &&
                <>
                    <Header
                        title={t("retentions.title-view")}
                        child={
                            <div className='d-flex flex-row-reverse m-1'>
                                {resourceScreen?.delete === true &&
                                    <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                                }
                                <Button variant="outlined" onClick={() => { navigate("/retentions", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
                            </div>
                        }
                    />
                    {resourceScreen?.read &&
                        <>
                            <div>
                                <UpdateRetentions retentionPayload={retentionLocal} isEdit={resourceScreen?.update} />
                            </div>
                        </>
                    }
                </>
            }
            <GenericDialog
                title={t("generic.dialog.delete")}
                content={t("retentions.dialog.delete")}
                open={openDialog}
                setOpen={setOpenDialog}
                onAcept={onDelete}
            />
            <SnackbarComponent/>
        </>
    )
}
